import React, { useEffect, useState } from "react";
import Heading from "../../tailwindUI/Heading";
import Navbar from "../../tailwindUI/Navbar";
import classes from "../../module.css/AllocationAwaited.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import Pagination from "../../tailwindUI/Pagination";
import DataNotFound from "../../Components/DataNotFound";
import ErrorMessage from "../../tailwindUI/ErrorMessage";
import SuccessMessage from "../../tailwindUI/SuccessMessage";
import TableHeader from "../../Components/TableHeader";
import ExcelDownload from "../../Components/ExcelDownload/ExcelDownload";
import Button from "../../tailwindUI/Button";
import Modal from "../../tailwindUI/Modal";
import { fetchAllocatedBookingTransfers } from "../../Services/BookingTransferService";

const StmPendingBookingTransfers = () => {
  const [listdata, setListdata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [allExcelData, setAllExcelData] = useState([]);
  const [message, setMessage] = useState("");
  const [apiFailled, setApiFailled] = useState(false);

  const UserToken = localStorage.getItem("UserToken");
  const navigate = useNavigate();

  const location = useLocation();
  const pathname = window.location.pathname;
  const queryParams = new URLSearchParams(location.search);
  const page = parseInt(queryParams.get("page")) ? queryParams.get("page") : 1;
  const maxPages = Math.ceil(totalCount / 20);

  const LogOut = () => {
    localStorage.removeItem("UserName");
    localStorage.removeItem("FirstName");
    localStorage.removeItem("LastName");
    localStorage.removeItem("UserToken");
    localStorage.removeItem("UserRole");
    localStorage.removeItem("Location");
    localStorage.removeItem("Email");
    localStorage.removeItem("UserLoggedin");
    navigate("/login", { replace: true });
  };

  useEffect(() => {
    fetchPendingBookingTransfers();
  }, [searchTerm === "", page]);

  // Auto-refresh every 30 seconds to pick up newly completed transfers
  useEffect(() => {
    const interval = setInterval(() => {
      fetchPendingBookingTransfers();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchPendingBookingTransfers = async () => {
    setLoading(true);
    try {
      const data = await fetchAllocatedBookingTransfers();
      
      console.log("Fetched allocated booking transfers:", data); // Debug log

      // Show ALL allocated booking transfers
      let filteredData = data;

      // Apply search filter if searchTerm exists
      if (searchTerm && searchTerm.trim() !== "") {
        const searchLower = searchTerm.toLowerCase();
        filteredData = data.filter((item) => {
          return (
            (item.OldWingsId && item.OldWingsId.toLowerCase().includes(searchLower)) ||
            (item.NewWingsId && item.NewWingsId.toLowerCase().includes(searchLower)) ||
            (item.OldBookingNo && item.OldBookingNo.toLowerCase().includes(searchLower)) ||
            (item.OldCustomerFullName && item.OldCustomerFullName.toLowerCase().includes(searchLower)) ||
            (item.NewCustomerFullName && item.NewCustomerFullName.toLowerCase().includes(searchLower)) ||
            (item.OldReceiptNo && item.OldReceiptNo.toLowerCase().includes(searchLower)) ||
            (item.NewReceiptNo && item.NewReceiptNo.toLowerCase().includes(searchLower)) ||
            (item.Showroom && item.Showroom.toLowerCase().includes(searchLower))
          );
        });
      }

      setTotalCount(filteredData.length);
      
      // Pagination
      const startIndex = (page - 1) * 20;
      const endIndex = startIndex + 20;
      const paginatedData = filteredData.slice(startIndex, endIndex);
      
      setListdata(paginatedData);
      setAllExcelData(filteredData);
    } catch (error) {
      console.error("Error fetching booking transfers:", error);
      setErrorMessage("Failed to fetch booking transfers. Please contact support.");
    } finally {
      setLoading(false);
    }
  };

  const dateHandler = (date) => {
    if (!date) return "N/A";
    const dateObj = new Date(date);
    const day = dateObj.getDate();
    const monthNameLong = dateObj.toLocaleString("en-US", { month: "short" });
    const year = dateObj.getFullYear();
    return (day <= 9 ? "0" : "") + day + "-" + monthNameLong + "-" + year;
  };

  const successMessage = () => {
    setTimeout(() => {
      setMessage("");
    }, 2000);
    return message;
  };

  const BreadCrumb = {
    pagename: "Pending Booking Transfers",
    pagePath: "/stm-pending-booking-transfers",
    pagename1: "",
    pagePath1: "",
  };

  const BreadCrumHomeLink = "/stm-dashboard";

  return (
    <>
      {errorMessage && <ErrorMessage message={errorMessage} />}
      {message && (
        <SuccessMessage
          onClose={() => setMessage("")}
          message={successMessage()}
          apiFailled={apiFailled}
        />
      )}
      <Navbar navbarType={"black navbar"} />
      <Heading
        headingType={"Page Headings"}
        headingText={"Pending Booking Transfers"}
        BreadCrumb={BreadCrumb}
        BreadCrumHomeLink={BreadCrumHomeLink}
      />
      <div className={classes.maincontainter}>
        <TableHeader
          buttonText="Search"
          tableHeading="Search Criteria"
          subHeading="subHeading"
          totalResult={totalCount}
          pageResult={listdata.length}
          placeholderType="Enter Wings Booking ID, Booking No, Customer Name, Receipt No, Showroom"
          apicall={fetchPendingBookingTransfers}
          setSearchTerm={setSearchTerm}
          searchTerm={searchTerm}
        />
        
        <div>
          <div className="my-2 text-end">
            <ExcelDownload
              csvData={allExcelData}
              fileName="Pending Booking Transfers"
            />
          </div>
        </div>

        {loading ? (
          <div className={"w-full bg-white"}>
            <img
              className="m-auto"
              src="../assets/loadingGif.gif"
              alt="loading"
            />
          </div>
        ) : (
          <div className={classes.list}>
            <div className={classes.stackListContainer}>
              <div role="list" className={classes.stackListWrapper}>
                {listdata?.length > 0 ? (
                  listdata?.map((item, index) => {
                    return (
                      <ul key={index} role="list" className="divide-y divide-gray-200 bg-white mb-2 rounded shadow">
                        <li>
                          <div className="hover:bg-gray-50 flex items-center pl-4">
                            <div className="font-bold">{(page - 1) * 20 + index + 1}</div>
                            <div className="w-full py-4 px-6 font-medium overflow-x-auto flex justify-between items-center">
                              <div className="flex-1">
                                <div className="flex items-center justify-between">
                                  <p className="flex items-center text-sm text-gray-600 flex-wrap">
                                    {item.OldBookingNo && (
                                      <>
                                        <span className="font-semibold">Old Wings Booking ID:</span>
                                        <span className="ml-2 mr-4">{item.OldBookingNo}</span>
                                      </>
                                    )}
                                    {item.NewWingsId && (
                                      <>
                                        <span className="font-semibold">New Wings Booking ID:</span>
                                        <span className="ml-2 mr-4">{item.NewWingsId}</span>
                                      </>
                                    )}
                                    {item.OldWingsId && (
                                      <>
                                        <span className="font-semibold">Booking No:</span>
                                        <span className="ml-2 mr-4">{item.OldWingsId}</span>
                                      </>
                                    )}
                                    {item.BookingTransferDate && (
                                      <>
                                        <span className="font-semibold">Transfer Date:</span>
                                        <span className="ml-2">{dateHandler(item.BookingTransferDate)}</span>
                                      </>
                                    )}
                                  </p>
                                </div>
                              <div className="flex items-center justify-between mt-2">
                                <p className="text-sm text-gray-900 flex-wrap">
                                  {(item.OldCustomerFullName || item.NewCustomerFullName) && (
                                    <>
                                      <span className="font-semibold">Customer Transfer:</span>
                                      <span className="ml-2">
                                        {item.OldCustomerFullName || "N/A"} → {item.NewCustomerFullName || "N/A"}
                                      </span>
                                    </>
                                  )}
                                </p>
                              </div>
                              <div className="flex items-center justify-between mt-2">
                                <p className="text-sm text-gray-600 flex-wrap">
                                  {item.OldReceiptNo && (
                                    <>
                                      <span className="font-semibold">Old Receipt:</span>
                                      <span className="ml-2 mr-4">{item.OldReceiptNo}</span>
                                    </>
                                  )}
                                  {item.NewReceiptNo && (
                                    <>
                                      <span className="font-semibold">New Receipt:</span>
                                      <span className="ml-2 mr-4">{item.NewReceiptNo}</span>
                                    </>
                                  )}
                                  {item.Showroom && (
                                    <>
                                      <span className="font-semibold">Showroom:</span>
                                      <span className="ml-2">{item.Showroom}</span>
                                    </>
                                  )}
                                </p>
                              </div>
                              {(item.CreatedDate || item.UpdatedDate) && (
                                <div className="flex items-center justify-between mt-2">
                                  <p className="text-sm text-gray-500 flex-wrap">
                                    {item.CreatedDate && (
                                      <>
                                        <span className="font-semibold">Created:</span>
                                        <span className="ml-2 mr-4">{dateHandler(item.CreatedDate)}</span>
                                      </>
                                    )}
                                    {item.UpdatedDate && (
                                      <>
                                        <span className="font-semibold">Updated:</span>
                                        <span className="ml-2">{dateHandler(item.UpdatedDate)}</span>
                                      </>
                                    )}
                                  </p>
                                </div>
                              )}
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    );
                  })
                ) : (
                  <DataNotFound />
                )}
              </div>
            </div>

            <div className="bg-white">
              {maxPages > 1 && <Pagination maxPages={maxPages} />}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default StmPendingBookingTransfers;
